module.exports = __webpack_public_path__ + "img/hertford_b3.9b858392.jpg";